import React from "react";
import styled, { useTheme } from "styled-components";
import Typography from "./Typography";
import { useTranslation } from "react-i18next";
import Alert from "../icons/Alert";

interface Props {
  error: string;
  className?: string;
  options?: object;
}

const ErrorMessage = ({ error, className, options }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Container className={`error-message ${className ? className : ""}`}>
      <Alert fill={theme.redesign.errorColor} />
      <Typography>{t(error, options)}</Typography>
    </Container>
  );
};

const Container = styled.span`
  align-items: center;
  background: ${({ theme }) => theme.redesign.defaultBackground};
  border: 1px solid ${({ theme }) => theme.redesign.errorColor};
  box-sizing: border-box;
  color: ${({ theme }) => theme.redesign.errorColor};
  display: flex;
  line-height: 16px;
  min-height: 36px;
  padding: 9px;

  /* TODO: replace it when Custom icon wrapper is ready */
  svg {
    height: 15px;
    width: 17px;
    margin-right: 9px;
  }
`;

export default ErrorMessage;
